import logger from "../../../util/logger";
import React from 'react';
import cx from 'classnames';
import { extractElement } from "../../../util";
import { whitelistStyles } from "../../core/hoc";
import { createComponent, PropTypes, Utils } from "../../../wayin-react"; // import enums

import { sizes } from "../../../enums"; //import components

import Header from "../../core/header"; // create component

var LoadingState = createComponent({
  displayName: 'LoadingStateCmp',
  propTypes: {
    height: PropTypes.oneOf([sizes.X1, sizes.S, sizes.M, sizes.L]),
    spinnerSize: PropTypes.oneOf([sizes.X1, sizes.S, sizes.M, sizes.L]),
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  },
  defaultProps: {
    height: sizes.S,
    spinnerSize: sizes.M,
    header: undefined
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(p) {
    var _cx2;

    var _headerIsValidType = p.header && (Utils.isType([Header], p.header) || typeof p.header === 'string');

    var _header;

    var _cx = cx((_cx2 = {
      ck: true,
      'loading-state': true,
      'loading-state--inverted': p.isInverted
    }, _cx2["loading-state--" + p.height] = p.height, _cx2["loading-state--spinner-" + p.spinnerSize] = p.spinnerSize, _cx2));

    var _cxSpinner = cx({
      'loading-spinner': true
    });

    logger.warn('LoadingState header props is not intended for use with anything other than a header component.  Please pass Header or string instead.', !!p.header && !_headerIsValidType);
    if (_headerIsValidType) _header = extractElement(Header, p.header, 'text');
    return /*#__PURE__*/React.createElement("div", {
      className: _cx,
      style: p.style
    }, /*#__PURE__*/React.createElement("div", {
      className: "loading-state__inner"
    }, /*#__PURE__*/React.createElement("div", {
      className: _cxSpinner
    }, /*#__PURE__*/React.createElement("div", {
      className: "loading-spinner__line1"
    }), /*#__PURE__*/React.createElement("div", {
      className: "loading-spinner__line2"
    }), /*#__PURE__*/React.createElement("div", {
      className: "loading-spinner__line3"
    }), /*#__PURE__*/React.createElement("div", {
      className: "loading-spinner__line4"
    })), _header ? /*#__PURE__*/React.createElement("div", {
      className: "loading-state__text"
    }, _header.element) : null));
  }
});
export default whitelistStyles()(LoadingState);
//# sourceMappingURL=index.js.map